/**
 * Keep in sync with `services/improve-api/src/types/types/job-category.ts`.
 */

import { JobCategory } from "@buildwitt/identity-client";
const JOB_CATEGORY_LABEL_BY_IDENTITY_NAME: Readonly<Record<JobCategory, string>> = {
	[JobCategory.SkilledLabor]: "Skilled Labor",
	[JobCategory.EquipmentOperator]: "Equipment Operator",
	[JobCategory.EquipmentMaintenance]: "Equipment Maintenance",
	[JobCategory.ProjectSupervision]: "Project Supervision",
	[JobCategory.ProjectManagement]: "Project Management",
	[JobCategory.ProjectAdministration]: "Project Administration",
	[JobCategory.SafetyProfessional]: "Safety Professional",
	[JobCategory.EstimatingSales]: "Estimating Sales",
	[JobCategory.Management]: "Management",
	[JobCategory.Support]: "Support",
	[JobCategory.HumanResources]: "Human Resources",
	[JobCategory.SurveyConstructionTech]: "Survey Construction Tech"
} as const;

export const formatJobCategoryLabel = (stored: JobCategory | null | undefined): string | null => {
	if (stored == null) {
		return null;
	}
	return JOB_CATEGORY_LABEL_BY_IDENTITY_NAME[stored] ?? stored.toString();
};
